import React, { useState,useEffect   } from 'react'
import { Button, Popover, Radio, Select, List, Avatar, Menu } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { loadExportReportTypeData } from '../../appRedux/actions/Reports'
import IntlMessages from '../../util/IntlMessages'
import {
  DownloadOutlined,
  FileExcelOutlined,
  FileTextOutlined
} from '@ant-design/icons'
import { formatDisplayName } from '@formatjs/intl'
import { DownloadTableExcel } from 'react-export-table-to-excel'
import { checkIsWeb } from '../../appRedux/actions/MobAppFn'

const exportReportOptions = [
  {
    key: 1,
    label: 'components.reporting.exportreport.xlsxformat',
    value: 'xlsx',
    desc: 'for excel and other spreadsheet apps',
    icon: <FileExcelOutlined />
  },
  {
    key: 1,
    label: 'components.reporting.exportreport.csvformat',
    value: 'csv',
    desc: '',
    icon: <FileTextOutlined />
  }
]

const ExportReport = props => {
  const { app_export } = props
  const dispatch = useDispatch()
  const tableRef = props.tableRef

  //#region useState
  const [getIsExportPopoverVisible, setIsExportPopoverVisible] =
    React.useState(false)
  const [getExportReportOptions, setExportReportOptions] =
    React.useState(exportReportOptions)
  const [getSelectedExportMenu, setSelectedExportMenu] = React.useState([1])

  //#endregion useState

  //#region Use Selector Start Region
  const getReduxExportReportType = useSelector(
    ({ Reports }) => Reports.exportReportType
  )


  //#endregion Use Selector End Region

  //#region for Use Effect Start Region
  // React.useEffect(() => {
  //   let mounted = true;
  //   if (mounted) {
  //     let jsonObj = {
  //       IsColumnFormat: isColumnFormat,
  //       FormatResultKey: getPeriodValue,
  //     };
  //     dispatch(loadFormatResultData(jsonObj));
  //     return () => (mounted = false);
  //   }
  // }, []);

  //#endregion for Use Effect End Region

  //#region Api Services
  //#endregion Api Services

  //#region onChange Functions

  const handleClickExport = exportObj => {
    setIsExportPopoverVisible(false)
    let selectedValue = [exportObj.key]
    setSelectedExportMenu(selectedValue)
    let exportFormat = exportObj.value
    dispatch(loadExportReportTypeData(exportFormat))
  }

  //#endregion onChange Functions

  const ExportReportPopoverContent = (
    <>
      <Menu defaultSelectedKeys={getSelectedExportMenu}>
        {getExportReportOptions &&
          getExportReportOptions != undefined &&
          getExportReportOptions.length > 0 &&
          getExportReportOptions.map((exportObj, key) => {
            return (
              <Menu.Item
                key={key}
                icon={exportObj.icon}
                onClick={() => {
                  handleClickExport(exportObj)
                }}
              >
                <IntlMessages id={exportObj.label} />
              </Menu.Item>
            )
          })}
      </Menu>
    </>
  )

  return (
    <>
      {/* <Popover
        // placement="left"
        //  title={promoCodeTitle}
        placement="bottomLeft"
        content={ExportReportPopoverContent}
        trigger="click"
        onVisibleChange={() => {
          setIsExportPopoverVisible(!getIsExportPopoverVisible);
        }}
        visible={getIsExportPopoverVisible}
      >
        <DownloadTableExcel
          filename="Dakar Reports"
          sheet="Reports"
          currentTableRef={tableRef.current}
        >
          <Button
            className="dk-format-btn dk-btn--text-supplementary "
            icon={<DownloadOutlined className="dk-btn-icon-align" />}
          >
            <IntlMessages id="components.reporting.exportreport.exportreport" />
          </Button>
        </DownloadTableExcel>
      </Popover> */}
      {checkIsWeb().exist ? (
        <DownloadTableExcel
          filename='Dakar Reports'
          sheet='Reports'
          currentTableRef={tableRef.current}
        >
          <Button
            className='dk-format-btn dk-btn--text-supplementary'
            icon={<DownloadOutlined className='dk-btn-icon-align' />}
          >
            <IntlMessages id='components.reporting.exportreport.exportreport' />
          </Button>
        </DownloadTableExcel>
      ) : (
        <Button
          onClick={app_export}
          className='dk-format-btn dk-btn--text-supplementary'
          icon={<DownloadOutlined className='dk-btn-icon-align' />}
        >
          <IntlMessages id='components.reporting.exportreport.exportreport' />
        </Button>
      )}
    </>
  )
}

export default ExportReport
